import axios from 'axios'
import AuthenticationService from '../services/AuthenticationService'
import wait from '../lib/wait'

axios.interceptors.request.use(function (config) {
  wait.start()
  return AuthenticationService.refreshSession().then(() => Promise.resolve(config))
}, function (error) {
  wait.end()
  return Promise.reject(error)
})

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  wait.end()
  return response
}, function (error) {
  wait.end()
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/lib/axios.js